import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import siteConfig, { formatPrice } from "../config/siteConfig";

function Main() {
  const [heroLoaded, setHeroLoaded] = useState(false);
  const featured = productData.filter((product) => product.featured).slice(0, 6);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="field-home">
      <section className="field-hero" aria-labelledby="field-hero-title">
        <div className="field-hero__copy">
          <p className="field-kicker">Field notes / 01</p>
          <h1 id="field-hero-title">Clothes for the whole day.</h1>
          <p className="field-hero__intro">
            Useful shapes, tactile cloth and colour with a point of view. Made for movement,
            repetition and wardrobes that grow slowly.
          </p>
          <Link className="field-link" to="/shop" onClick={toTop}>Shop all 32 pieces</Link>
        </div>
        <div className={`field-hero__media ${heroLoaded ? "is-loaded" : ""}`}>
          <img
            src="/main/hero-original.jpg"
            alt="Four original garments arranged on a cobalt background"
            onLoad={() => setHeroLoaded(true)}
            loading="eager"
            decoding="async"
          />
          {!heroLoaded && <span aria-label="Loading collection image" />}
        </div>
      </section>

      <nav className="field-categories" aria-label="Shop by category">
        <Link to="/shop?category=Denim%20Pants" onClick={toTop}>Denim</Link>
        <Link to="/shop?category=Tops%20%2F%20Jackets" onClick={toTop}>Layers</Link>
        <Link to="/shop?category=Knitwear" onClick={toTop}>Knitwear</Link>
        <Link to="/shop?category=Dresses%20%2F%20Jumpsuit" onClick={toTop}>One-piece</Link>
      </nav>

      <section className="field-picks" aria-labelledby="field-picks-title">
        <div className="field-section-head">
          <div>
            <p className="field-kicker">A short list</p>
            <h2 id="field-picks-title">Start here</h2>
          </div>
          <Link className="field-link" to="/shop" onClick={toTop}>See the full catalogue</Link>
        </div>
        <div className="field-picks__grid">
          {featured.map((product, index) => (
            <Link className={`field-product field-product--${index + 1}`} to={`/shopDetails/${product.id}`} key={product.id} onClick={toTop}>
              <div className="field-product__image">
                <img src={product.image} alt={product.name} loading="lazy" />
                <span>{String(index + 1).padStart(2, "0")}</span>
              </div>
              <div className="field-product__meta">
                <h3>{product.name}</h3>
                <p>{formatPrice(product.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="field-statement" aria-labelledby="field-statement-title">
        <p className="field-kicker">Our working rule</p>
        <h2 id="field-statement-title">We design for repeat wear.</h2>
        <div>
          <p>A strong garment should make mornings easier, hold up to ordinary life and become more familiar with time. That idea guides our shapes, materials and care advice.</p>
          <Link className="field-link field-link--light" to="/responsibility" onClick={toTop}>Read our responsibility notes</Link>
        </div>
      </section>

      <section className="field-journal" aria-labelledby="field-journal-title">
        <div className="field-section-head">
          <div>
            <p className="field-kicker">Ways to wear</p>
            <h2 id="field-journal-title">Three routes in</h2>
          </div>
        </div>
        <div className="field-journal__grid">
          <Link to="/shop?department=Woman" onClick={toTop}>
            <img src="/main/woman-original.jpg" alt="Woman walking beside a bright blue wall" loading="lazy" />
            <span><small>Woman</small>Easy layers</span>
          </Link>
          <Link to="/shop?department=Man" onClick={toTop}>
            <img src="/main/man-original.jpg" alt="Man seated on a yellow bench" loading="lazy" />
            <span><small>Man</small>Everyday shape</span>
          </Link>
          <Link to="/care" onClick={toTop}>
            <img src="/main/repair-original.jpg" alt="Hands repairing a garment on a worktable" loading="lazy" />
            <span><small>Care</small>Keep it moving</span>
          </Link>
        </div>
      </section>

      <section className="field-materials" aria-labelledby="field-materials-title">
        <div className="field-materials__media">
          <img src="/main/materials-original.jpg" alt="Colourful fabric rolls arranged on blue shelves" loading="lazy" />
        </div>
        <div className="field-materials__copy">
          <p className="field-kicker">Material desk / 02</p>
          <h2 id="field-materials-title">Look closely. Ask better questions.</h2>
          <ol>
            <li><span>01</span>Choose cloth for durability and comfort.</li>
            <li><span>02</span>Share what is known about fibres and care.</li>
            <li><span>03</span>Make repair part of a garment's life.</li>
          </ol>
          <Link className="field-link" to="/about" onClick={toTop}>How we work</Link>
        </div>
      </section>

      <section className="field-signoff">
        <p>{siteConfig.brandName}</p>
        <h2>Wear often. Repair when needed. Pass it on.</h2>
        <Link to="/shop" onClick={toTop}>Browse the collection</Link>
      </section>
    </main>
  );
}

export default Main;
